import { ThunkDispatch } from 'store/store';
import State from 'store/State';
import Services from 'store/Services';
import { showWarningAsync } from 'notification/store/thunks';
import {
    CurrencyActionSetCurrencies,
    setCurrencies,
} from 'app/currencies/store/actions';
import { buildLoggerForStore } from 'logging/writers/utils';

const log = buildLoggerForStore('currencies');

export const loadCurrencies =
    (currencySymbols: string[]) =>
    async (
        dispatch: ThunkDispatch<CurrencyActionSetCurrencies>,
        _getState: () => State,
        { currencyService, loggingService }: Services
    ) => {
        log(loggingService, 'loadCurrencies', {
            currencySymbols,
        });
        try {
            const currencies =
                await currencyService.loadCurrencies(currencySymbols);
            if (currencies.length > 0) {
                dispatch(setCurrencies(currencies));
            }
        } catch (err) {
            dispatch(showWarningAsync('Error loading currencies'));
        }
    };
